<script setup lang="ts">
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  FileIcon,
  GiftIcon,
  HomeIcon,
  ImageIcon,
  InfoCircleIcon,
  LocationIcon,
  OrderListIcon,
  ScanIcon,
  SearchIcon,
  ServiceIcon,
  ShopIcon,
  TaskIcon,
  UserAddIcon,
  UserIcon,
  WalletIcon,
} from 'tdesign-icons-vue-next'
import type { Component } from 'vue'

export type AppIconName =
  | 'check-circle'
  | 'chevron-left'
  | 'chevron-right'
  | 'file'
  | 'gift'
  | 'home'
  | 'image'
  | 'info-circle'
  | 'location'
  | 'order-list'
  | 'scan'
  | 'search'
  | 'service'
  | 'shop'
  | 'task'
  | 'user-add'
  | 'user'
  | 'wallet'

withDefaults(defineProps<{
  name: AppIconName
  size?: string
  /** 纯装饰图标(默认)对辅助技术隐藏;语义图标需自行提供文本标签。 */
  decorative?: boolean
}>(), {
  size: '1em',
  decorative: true,
})

const icons: Record<AppIconName, Component> = {
  'check-circle': CheckCircleIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  file: FileIcon,
  gift: GiftIcon,
  home: HomeIcon,
  image: ImageIcon,
  'info-circle': InfoCircleIcon,
  location: LocationIcon,
  'order-list': OrderListIcon,
  scan: ScanIcon,
  search: SearchIcon,
  service: ServiceIcon,
  shop: ShopIcon,
  task: TaskIcon,
  'user-add': UserAddIcon,
  user: UserIcon,
  wallet: WalletIcon,
}
</script>

<template>
  <component :is="icons[name]" :size="size" :aria-hidden="decorative ? 'true' : undefined" />
</template>
